var dateFormat = require("dateformat");

function safeTimeConversion(date, format) {
  try {
    return dateFormat(date, format, true);
  } catch (err) {
    return "N/A";
  }
}
export function yearMonthDayFormat(date) {
  return safeTimeConversion(date, "yyyy-mm-dd");
}

export function yearMonthDayTimeFormat(date) {
  return safeTimeConversion(date, "yyyy-mm-dd hh:MM tt");
}
